module.exports = __webpack_public_path__ + "static/media/medical-reserve-piggy.30c7a9b2.webp";